import { isFilled } from '@prismicio/client';

import {
  LinkIcon,
  GradientBorder,
  AllStandardColourOptions,
  LinkVariant,
} from '@preventx/oxygen';

// Types
import { ActionLink } from '@/types/components/actions';

// Components
import { Link } from '@/components/Actions/Link';

type ActionLinksProps = {
  idPrefix: string;
  actions: ActionLink[];
  addBorderGradiant?: boolean;
};

export const ActionLinks = ({
  actions,
  idPrefix,
  addBorderGradiant,
}: ActionLinksProps) => (
  <>
    {(actions ?? []).map((item, index) => {
      const { action, icon } = item;
      const { variant, text } = action;

      const key = `${idPrefix}-${index + 1}`;

      if (!isFilled.link(action)) {
        return null;
      }

      const colour = {
        Default: undefined,
        Contrast: undefined,
        Secondary: undefined,
        Primary: 'primary' satisfies AllStandardColourOptions,
        Negative: 'negative' satisfies AllStandardColourOptions,
      }[variant ?? 'Default'] as AllStandardColourOptions;

      const iconConfiguration: LinkIcon | undefined = icon
        ? {
            definition: icon,
            position: 'right',
            addDirectionalIcon: true,
          }
        : undefined;

      let linkVariant: LinkVariant = 'solid';

      if (item.addOutline) {
        linkVariant = 'outline';
      } else if (variant === 'Contrast') {
        linkVariant = 'contrast';
      }

      if (addBorderGradiant) {
        return (
          <GradientBorder component="div" key={`${idPrefix}-${index + 1}`}>
            <Link
              key={key}
              size="lg"
              as="default"
              href={action}
              type="button"
              rel="nofollow"
              colour={colour}
              retainSearchParams
              variant={linkVariant}
              icon={iconConfiguration}
            >
              {text}
            </Link>
          </GradientBorder>
        );
      }

      return (
        <Link
          key={key}
          size="lg"
          as="default"
          href={action}
          type="button"
          rel="nofollow"
          colour={colour}
          retainSearchParams
          variant={linkVariant}
          icon={iconConfiguration}
        >
          {text}
        </Link>
      );
    })}
  </>
);
